module.exports = __webpack_public_path__ + "img/roadmap-mb.f2eda18a.png";